"use strict";
exports.__esModule = true;
var TextareaAutosize_1 = require("./TextareaAutosize");
exports["default"] = TextareaAutosize_1.TextareaAutosize;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-autosize-textarea/lib/index.js
// module id = 42
// module chunks = 0